import PropTypes from 'prop-types';
import DropdownItem from './DropdownItem';

const DropdownMenu = props => {
  const { children, disabled, title, icon } = props;

  return (
    <div className="dropdown-submenu">
      <DropdownItem disabled={disabled} icon={icon}>
        {title}
      </DropdownItem>
      <div className="dropdown-menu">{children}</div>
    </div>
  );
};

DropdownMenu.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string
};

DropdownMenu.defaultProps = {
  disabled: false,
  icon: ''
};

export default DropdownMenu;
